import React from 'react';
import { Typography } from 'antd';
import { motion } from 'framer-motion';
import { useTranslation } from 'react-i18next';

const { Text } = Typography;

const fadeUp = {
    initial: { opacity: 0, y: 20 },
    whileInView: { opacity: 1, y: 0 },
    transition: { duration: 0.6 },
    viewport: { once: true },
};

// Danh sách các công ty (logo placeholder)
const companies = [
    { name: 'Đồng Xanh GFD', color: '#69c0ff' },
    { name: 'Cổ phần VCCC', color: '#95de64' },
    { name: 'Mai Sơn Vina', color: '#d3adf7' },
];

const TrustedBySection: React.FC = () => {
    const { t } = useTranslation();

    return (
        <div
            style={{
                position: 'relative',
                zIndex: 1,
                padding: '40px 20px',
                background: 'rgba(0,0,0,0.2)',
            }}
        >
            <motion.div {...fadeUp} style={{ textAlign: 'center' }}>
                <Text
                    style={{
                        color: 'rgba(255,255,255,0.6)',
                        fontSize: '0.8rem',
                        letterSpacing: '0.5px',
                        textTransform: 'uppercase',
                        fontWeight: 600,
                    }}
                >
                    {t('landing__trusted_by')}
                </Text>

                <div
                    style={{
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        gap: 24,
                        marginTop: 24,
                        flexWrap: 'wrap',
                    }}
                >
                    {companies.map((company, index) => (
                        <motion.div
                            key={index}
                            initial={{ opacity: 0, y: 10 }}
                            whileInView={{ opacity: 1, y: 0 }}
                            transition={{ duration: 0.5, delay: index * 0.1 }}
                            viewport={{ once: true }}
                            style={{
                                color: 'rgba(255,255,255,0.4)',
                                fontSize: '0.9rem',
                                fontWeight: 700,
                                letterSpacing: '0.5px',
                            }}
                        >
                            {company.name}
                        </motion.div>
                    ))}
                </div>
            </motion.div>
        </div>
    );
};

export default TrustedBySection;
